module.exports = __webpack_public_path__ + "media/educator_advisory_board/fw_advisory_board_header-774ce89b.png";